import React from 'react';
import {Col, Row} from "reactstrap";
import task from "../../../resources/icons/task.png";
import people from "../../../resources/icons/people.png";
import thought from "../../../resources/icons/thought.png";

export default class Home extends React.Component {

    render() {
        return <Row className={'ilead-tools-home-page'}>
            <Col sm={12} md={4}>
                <img onClick={this.props.handleChangePage('People')} src={people} alt=""/>
                <div className="d-flex justify-content-center mt-4">
                    <div onClick={this.props.handleChangePage('People')}
                         className="button-next-previous-done text-white">Review
                    </div>
                </div>
            </Col>
            <Col sm={12} md={4}>
                <img onClick={this.props.handleChangePage('Thought')} src={thought} alt=""/>

                <div className="d-flex justify-content-center mt-4">
                    <div onClick={this.props.handleChangePage('Thought')}
                         className="button-next-previous-done thought text-white">Review
                    </div>
                </div>
            </Col>
            <Col sm={12} md={4}>
                <img onClick={this.props.handleChangePage('Task')} src={task} alt=""/>

                <div className="d-flex justify-content-center mt-4">
                    <div onClick={this.props.handleChangePage('Task')}
                         className="button-next-previous-done task text-white">Review
                    </div>
                </div>
            </Col>
        </Row>;
    }
}